import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import UploadFile from '../../component/dccore-form/uploadFile.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'

if ($('#region_import_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#region_import_form',
    components: {
      RingLoader,
      UploadFile,
      Checkbox
    },
    mixins: [mixins],
    data: {
      loading: 0,
      file: null,
      errors: {},
      global : false,
      fileUploading: false,
      result: null,
    },
    mounted: function () {
      this.$on('fileUploading', (v) => {
        this.fileUploading = v
      })
    },
    methods: {
      closeModal() {
        $(location).attr('href', Routing.generate('region_import'))
        $('#resultModal').modal('hide')
      },
      importKML() {
        this.loading++
        let url = Routing.generate('api_import_region')
        let data = {
          file : this.file,
          global: this.global
        }
        this.$http.post(url, data).then(response => {
          this.result = response.data
          $('#resultModal').modal()
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
    }
  })
}
